import React from "react";


type Props = {
    src: string;
    [x:string]: any;
};

// const Image = ({ src, ...props }) => {
const Image = ({ src, ...props }: Props) => {
//   try {
//     return React.createElement(require.resolve("next/image").default, {
//       src: typeof src === "string" ? src : src.src,
//       ...props
//     });
//   } catch {
//     console.log("Not using Next.js");
//     return React.createElement("img", { src, ...props });
//   }
    return React.createElement("img", { src, ...props });
};

export default Image;